import React from 'react';
import { Flex, Group, TextInput } from '@mantine/core';
import IonIcon from '@reacticons/ionicons';

interface LevelFieldProps {
    cpIndex: number;
    levelValue: string;
    handleLevelChange: (newValue: string | null) => void;
    handleRemoveLevel: () => void;
}

export const LevelField: React.FC<LevelFieldProps> = ({
    cpIndex,
    levelValue,
    handleLevelChange,
    handleRemoveLevel,
}) => {
    return (
        <div key={cpIndex}>
            <Flex direction={'column'}>
                <Group
                    grow
                    style={{
                        width: '101%',
                        height: '25%',
                        paddingBottom: '10px',
                        display: 'flex',
                        alignItems: 'center',
                        marginLeft: '0%',
                    }}
                >
                    <Group w='50%' grow>
                        <TextInput
                            w="100%"
                            label={`Level ${cpIndex + 1}`}
                            placeholder="Enter Rating Information"
                            withAsterisk
                            onChange={(event) => {
                                handleLevelChange(event.target.value);
                            }}
                            value={levelValue}
                        />
                    </Group>
                    {cpIndex !== 0 && (
                        <Group w='40%' style={{ paddingRight: '5%', marginTop: '1%' }} grow>
                            <div
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'flex-end',
                                }}
                            >
                                <IonIcon name="trash-outline" className="click-ion-icon" style={{ width: '20px', height: '20px', color: "red" }}
                                    onClick={handleRemoveLevel} />
                                <span
                                    style={{
                                        fontFamily: 'Plus Jakarta Sans',
                                        color: '#111928',
                                        fontSize: '12px',
                                        fontWeight: 'bold',
                                    }}
                                >
                                    Remove Level
                                </span>
                            </div>
                        </Group>
                    )}
                </Group>
            </Flex>
        </div>
    );
};